import type React from "react";
import type { ReactNode } from "react";

import { useReactTooltip } from "hooks/useReactTooltip";
import { ParagraphMedium } from "styles/elements/Texts";
import { StyledBox } from "./ProgressStatBox.styled";

interface ProgressStatBoxProps {
  dataCy?: string;
  title: string;
  tooltip?: string;
  startIcon?: ReactNode;
  value: ReactNode; // Value is expected to be a node of these types: CssFlex, Heading3
}

export const ProgressStatBox: React.FC<ProgressStatBoxProps> = ({
  dataCy,
  title,
  tooltip,
  value,
  startIcon,
}) => {
  useReactTooltip(!!tooltip);
  return (
    <StyledBox data-cy={dataCy}>
      {startIcon}
      <div>
        <ParagraphMedium>{title}</ParagraphMedium>
        {value}
      </div>
    </StyledBox>
  );
};
